export enum ControlType {
    Checkbox = 'checkbox',
    Text = 'text',
    Date = 'date',
    EncryptedText = 'encrypted-text',
    Encrypted_Text = 'encrypted text',
    Numeric = 'numeric',
    Formula = 'formula',
    MultiSelect = 'multi-select',
    Picklist = 'picklist',
    Textbox = 'textbox',
    Radio = 'radio',
    DateRange = 'daterange',
}

export enum DbControlType {
    Checkbox = 'CHECKBOX',
    Text = 'TEXT',
    Date = 'DATE',
    EncryptedText = 'ENC_TEXT',
    Numeric = 'NUMERIC',
    Formula = 'FORMULA',
    MultiSelect = 'MULTISELECT',
    Picklist = 'PICKLIST',
    Textbox = 'TEXTBOX',
    Radio = 'RADIO'
}
